import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CoveoAINotification = _resolveComponent("CoveoAINotification");
  return _openBlock(), _createBlock(_component_CoveoAINotification, {
    displayIcon: $data.displayIcon,
    isCoveoExpanded: $data.isCoveoExpanded,
    "onUpdate:isCoveoExpanded": _cache[2] || (_cache[2] = $event => $data.isCoveoExpanded = $event),
    componentStyle: "loggedOut"
  }, {
    "panel-title": _withCtx(() => [_createTextVNode(_toDisplayString($data.contentTitle), 1)]),
    "panel-content": _withCtx(() => [_createElementVNode("p", null, [_createElementVNode("a", {
      href: "javascript:void(0)",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.loginClick && $options.loginClick(...args)),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers((...args) => $options.loginClick && $options.loginClick(...args), ["prevent"]), ["enter"])),
      tabindex: "0"
    }, _toDisplayString($data.contentLoginLinkTitle), 33), _hoisted_1, _createTextVNode(" " + _toDisplayString($data.contentDescription), 1)])]),
    _: 1
  }, 8, ["displayIcon", "isCoveoExpanded"]);
}